export default class PlansByContract {
    idContrato: number;
    idClube: string;
    tipoContrato: number;
    idStatusContrato: number;
    tipoContratoPF: number;
    idAssociado: string;
    associadoNome: string;
    planos: PlanoModel[];

    constructor(
        idContrato: number,
        idClube: string,
        tipoContrato: number,
        idStatusContrato: number,
        tipoContratoPF: number,
        idAssociado: string,
        associadoNome: string,
        planos: PlanoModel[]
    ) {
        this.idContrato = idContrato;
        this.idClube = idClube;
        this.tipoContrato = tipoContrato;
        this.idStatusContrato = idStatusContrato;
        this.tipoContratoPF = tipoContratoPF;
        this.idAssociado = idAssociado;
        this.associadoNome = associadoNome;
        this.planos = planos;
    }

    static fromApiResponse(data: any): PlansByContract {
        const contrato = data.contratos?.[0] || {}; 
        return new PlansByContract(
            contrato.id_contrato,
            contrato.ID_CLUBE,
            contrato.tipo_contrato,
            contrato.ID_STATUS_CONTRATO,
            contrato.TIPO_CONTRATO_PF,
            contrato.ID_ASSOCIADO,
            contrato.associado?.nome || "",
            data.planos ? data.planos.map((plano: any) => PlanoModel.fromApiResponse(plano)) : []
        );
    }
}

export class PlanoModel {
    idContratoCategoria: number;
    valor: string;
    idCategoria: string;
    idContrato: number;
    categoria: string;
    num_contrato: string;
    ID_CLUBE: string;
    nome_fantasia: string;

    constructor(
        idContratoCategoria: number,
        valor: string,
        idCategoria: string,
        idContrato: number,
        categoria: string,
        num_contrato: string,
        ID_CLUBE: string,
        nome_fantasia: string
    ) {
        this.idContratoCategoria = idContratoCategoria;
        this.valor = valor;
        this.idCategoria = idCategoria;
        this.idContrato = idContrato;
        this.categoria = categoria;
        this.num_contrato = num_contrato;
        this.ID_CLUBE = ID_CLUBE;
        this.nome_fantasia = nome_fantasia
    }

    static fromApiResponse(data: any): PlanoModel {
        return new PlanoModel(
            data.id_contrato_categoria,
            data.valor,
            data.ID_CATEGORIA,
            data.id_contrato,
            data.cad_categoria?.categoria || "",
            data.sec_contrato.num_contrato,
            data.sec_contrato.ID_CLUBE,
            data.sec_contrato.adm_clubes.nome_fantasia
        );
    }
}
